import { StyledTextInput } from './text-input-style';

interface ITextInputProps {
  value: any,
  onChange: any,
  placeholder: string,
  type?: string
  id?: string,
  name?: string
}

export const TextInput = ({
  value,
  onChange,
  placeholder,
  id,
  name,
  type = "text"
}: ITextInputProps) => {
  return (
    <StyledTextInput name={name} id={id} type={type} value={value} onChange={onChange} placeholder={placeholder} />
  );
};